import { Models } from '@rematch/core'
import agreement from './agreement'
import application from './application'
import auth from './auth'
import basic from './basic'
import building from './building'
import chat from './chat'
import chatPreset from './chat-preset'
import companyManagement from './company-management'
import contract from './contract'
import endTenancy from './end-tenancy'
import error from './error'
import insurance from './insurance'
import listing from './listing'
import livScore from './liv-score'
import loading from './loading'
import master from './master'
import payment from './payment'
import plans from './plans'
import profile from './profile'
import session from './session'
import settlements from './settlements'
import sse from './sse'
import supportRoom from './support-room'
import toaster from './toaster'
import user from './user'

export interface RootModel extends Models<RootModel> {
  agreement: typeof agreement
  application: typeof application
  auth: typeof auth
  basic: typeof basic
  building: typeof building
  chat: typeof chat
  chatPreset: typeof chatPreset
  contract: typeof contract
  endTenancy: typeof endTenancy
  livScore: typeof livScore
  insurance: typeof insurance
  error: typeof error
  listing: typeof listing
  companyManagement: typeof companyManagement
  loading: typeof loading
  master: typeof master
  payment: typeof payment
  plans: typeof plans
  session: typeof session
  settlements: typeof settlements
  supportRoom: typeof supportRoom
  sse: typeof sse
  toaster: typeof toaster
  user: typeof user
  profile: typeof profile
}

const models: RootModel = {
  agreement,
  application,
  auth,
  basic,
  building,
  chat,
  chatPreset,
  contract,
  endTenancy,
  livScore,
  insurance,
  error,
  listing,
  companyManagement,
  loading,
  master,
  payment,
  plans,
  session,
  settlements,
  supportRoom,
  sse,
  toaster,
  user,
  profile
}

export default models
